import { Container } from '@awaze/design-system.components.container'
import { Section, SectionProps } from '@awaze/design-system.components.section'
import React from 'react'
import styled from 'styled-components'
import { ConditionalWrapper } from '@/components/ConditionalWrapper/ConditionalWrapper'
import {
  BaseGrid,
  BaseGridItem,
} from '@awaze/design-system.components.base-grid'

export const SECTION_PADDING = 24
export interface SectionValueProps
  extends Omit<SectionProps, 'children' | 'backgroundColor'> {
  layoutOption?: 'slim'
  backgroundColor:
    | 'transparent'
    | 'white' // White does not work with the design-system as it converts tokens into colors instead of taking actual css colors.
    | 'light-100'
    | 'secondary-400'
    | 'dark-100'
}

const SectionContainer = styled(BaseGrid)<{ slim: boolean }>`
  width: 100%;

  ${(p) =>
    p.slim &&
    `
    max-width: 75rem;
  `}
`
export const SectionModule: React.FC<
  {
    section: SectionValueProps
    handlesLayout?: boolean
  } & React.HTMLProps<HTMLDivElement>
> = ({ children, section, handlesLayout, ...props }) => {
  if (!section) {
    return (
      <ConditionalWrapper condition={!handlesLayout} Wrapper={Container}>
        {children}
      </ConditionalWrapper>
    )
  }

  const slim = section.layoutOption === 'slim'

  return (
    <Section
      {...(section as SectionProps)}
      {...props}
      style={
        handlesLayout
          ? { display: 'flex' }
          : { paddingLeft: SECTION_PADDING, paddingRight: SECTION_PADDING }
      }
    >
      <SectionContainer flush slim={slim}>
        <BaseGridItem
          columns={[12, slim ? 8 : 12, slim ? 8 : 12]}
          offsets={[0, slim ? 2 : 0, slim ? 2 : 0]}
          style={{ padding: 0 }}
        >
          <ConditionalWrapper condition={!handlesLayout} Wrapper={Container}>
            {children}
          </ConditionalWrapper>
        </BaseGridItem>
      </SectionContainer>
    </Section>
  )
}

export default SectionModule
